<template>
    <form-view class="custom-api-form-view" @submitsuccess="goToTest">
        <veui-steps :steps="steps"  :current="1"/>
        <template slot="field">
            <h3 class="section">新建API</h3>
            <veui-field label="接口名字："
                name="name"
                field="name"
                rules="required">
                <veui-input v-model="store.formData.name"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="协议类型："
                name="protocol"
                field="protocol"
                rules="required">
                <veui-select :options="store.protocolDatasource"
                    v-model="store.formData.protocol"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="请求方法："
                name="requestMethod"
                field="requestMethod"
                rules="required">
                <veui-select :options="store.methodDatasource"
                    v-model="store.formData.requestMethod"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="Content-Type："
                v-if="!isGetMethod"
                name="contentType"
                field="contentType"
                rules="required">
                <veui-select :options="store.contentTypeDatasource"
                    v-model="store.formData.contentType"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="原始URL："
                name="sourceUrl"
                field="sourceUrl"
                :rules="validator('required|httpUrl')">
                <veui-input v-model="store.formData.sourceUrl"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="代理URL："
                name="proxyUrl"
                field="proxyUrl"
                rules="required">
                <veui-input v-model="store.formData.proxyUrl"
                    :readonly="isDetail"/>
                <veui-span class="proxy-url">{{store.proxyUrlPrefix}}</veui-span>
            </veui-field>
            <veui-field label="编码方式："
                name="encoding"
                field="encoding"
                rules="required">
                <veui-select :options="store.encodingDatasource"
                    v-model="store.formData.encoding"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="认证类型："
                name="authType"
                field="authType"
                rules="required">
                <veui-select :options="store.authTypeDatasource"
                    v-model="store.formData.authType"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="认证附加信息："
                v-if="!isNoAuthType"
                name="authInfo"
                field="authInfo"
                rules="required">
                <veui-textarea v-model="store.formData.authInfo"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="签名算法类型："
                name="signType"
                field="signType"
                rules="required">
                <veui-select :options="store.signTypeDatasource"
                    v-model="store.formData.signType"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="签名位置："
                v-if="!isNoSignType"
                name="signLocation"
                field="signLocation"
                rules="required">
                <veui-select :options="store.locationDatasource"
                    v-model="store.formData.signLocation"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="签名key："
                v-if="!isNoSignType"
                name="signKey"
                field="signKey"
                rules="required">
                <veui-input v-model="store.formData.signKey"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="签名模板："
                v-if="!isNoSignType"
                name="signTemplate"
                field="signTemplate"
                rules="required">
                <veui-textarea v-model="store.formData.signTemplate"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="是否传递用户ID："
                name="requireUid"
                field="requireUid"
                rules="required">
                <veui-radio-group
                    :items="store.trueFalseDatasource"
                    :readonly="isDetail"
                    v-model="store.formData.requireUid"/>
            </veui-field>
            <veui-field
                :readonly="isDetail"
                tip="不同域名以逗号分隔"
                label="cors域名白名单:"
                name="corsDomainWhiteList"
                field="corsDomainWhiteList">
                <veui-textarea v-model="store.formData.corsDomainWhiteList"/>
            </veui-field>

            <h3 class="section">参数设置</h3>
            <veui-field label="已添加参数：" class="added-params">
                <veui-button class="primary-border-btn"
                    v-if="!isDetail"
                    ui="small"
                    @click="openAddParamDialog">添加参数</veui-button>
            </veui-field>
            <veui-table ui="slim alt"
                :data="store.formData.parameters"
                keys="name">
                <veui-table-column field="complexBodyParam" title="复杂参数">
                    <template slot-scope="props">
                        <veui-span>{{props.complexBodyParam | booleanText}}</veui-span>
                    </template>
                </veui-table-column>
                <veui-table-column field="name" title="参数名">
                    <template slot-scope="props">
                        <veui-span class="table-multi-line">{{props.name}}</veui-span>
                    </template>
                </veui-table-column>
                <veui-table-column field="required" title="是否必需">
                    <template slot-scope="props">
                        <veui-span>{{props.required | booleanText}}</veui-span>
                    </template>
                </veui-table-column>
                <veui-table-column field="defaultValue" title="默认值">
                    <template slot-scope="props">
                        <veui-span class="table-multi-line">{{props.defaultValue}}</veui-span>
                    </template>
                </veui-table-column>
                <veui-table-column field="location" title="位置"/>
                <veui-table-column field="type" title="参数类型"/>
                <veui-table-column field="description" title="参数说明">
                    <template slot-scope="props">
                        <veui-span class="table-multi-line">{{props.description}}</veui-span>
                    </template>
                </veui-table-column>
                <veui-table-column field="operations" title="操作" v-if="!isDetail">
                    <template slot-scope="props">
                        <veui-button ui="link primary" @click="editParameter(props.item.name)">修改</veui-button>
                        <veui-button ui="link primary" @click="removeParameter(props.item.name)">删除</veui-button>
                    </template>
                </veui-table-column>
            </veui-table>

            <h3 class="section">返回示例说明</h3>
            <veui-field label="返回示例说明："
                name="responseExample"
                field="responseExample"
                rules="required">
                <veui-textarea
                    v-model="store.formData.responseExample"
                    :readonly="isDetail"/>
            </veui-field>

            <h3 class="section">访问控制信息</h3>
            <veui-field label="QPS："
                name="qps"
                field="qps"
                rules="required">
                <veui-checkbox v-model="store.formData.qps"
                    true-value="-1"
                    false-value=""
                    :readonly="isDetail">不限</veui-checkbox>
                <veui-input v-if="store.formData.qps !== '-1'"
                    v-model="store.formData.qps"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="QPM："
                name="qpm"
                field="qpm"
                rules="required">
                <veui-checkbox v-model="store.formData.qpm"
                    true-value="-1"
                    false-value=""
                    :readonly="isDetail">不限</veui-checkbox>
                <veui-input v-if="store.formData.qpm !== '-1'"
                    v-model="store.formData.qpm"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="QPH："
                name="qph"
                field="qph"
                rules="required">
                <veui-checkbox v-model="store.formData.qph"
                    true-value="-1"
                    false-value=""
                    :readonly="isDetail">不限</veui-checkbox>
                <veui-input v-if="store.formData.qph !== '-1'"
                    v-model="store.formData.qph"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="QPD："
                name="qpd"
                field="qpd"
                rules="required">
                <veui-checkbox v-model="store.formData.qpd"
                    true-value="-1"
                    false-value=""
                    @change="limitChange('qpd')"
                    :readonly="isDetail">不限</veui-checkbox>
                <veui-input v-if="store.formData.qpd !== '-1'"
                    v-model="store.formData.qpd"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="Total Count："
                name="totalCount"
                field="totalCount"
                rules="required">
                <veui-checkbox v-model="store.formData.totalCount"
                    true-value="-1"
                    false-value=""
                    :readonly="isDetail">不限</veui-checkbox>
                <veui-input v-if="store.formData.totalCount !== '-1'"
                    v-model="store.formData.totalCount"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="接口稳定性："
                name="stability"
                field="stability"
                rules="required">
                <veui-select
                    :options="store.stabilityDatasource"
                    v-model="store.formData.stability"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="重试次数："
                name="retryCount"
                field="retryCount"
                rules="required">
                <veui-input
                    v-model="store.formData.retryCount"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="超时（秒）："
                name="timeout"
                field="timeout"
                rules="required">
                <veui-input
                    v-model="store.formData.timeout"
                    :readonly="isDetail"/>
            </veui-field>
            <veui-field label="缓存失效时间（秒）："
                name="cacheExpire"
                field="cacheExpire"
                rules="required">
                <veui-input
                    v-model="store.formData.cacheExpire"
                    :readonly="isDetail"/>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="!isDetail">
                <veui-button ui="primary" type="submit">保存并测试</veui-button>
                <veui-button @click="back">取消</veui-button>
            </template>
            <template v-if="isDetail">
                <veui-button ui="primary" @click="goToTest">查看沙盒测试</veui-button>
                <veui-button class="primary-border-btn" @click="back">返回上一步</veui-button>
                <veui-button @click="backToService">返回服务列表</veui-button>
            </template>
        </template>

        <template slot="after" v-if="!isDetail">
            <veui-dialog :open.sync="paramDialogVisible"
                overlay-class="parameter-dialog"
                title="添加参数"
                draggable>
                <veui-form ref="paramForm"
                    :data="store.parameter"
                    @submit="addParameter">
                    <veui-field label="复杂参数："
                        name="complexBodyParam"
                        field="complexBodyParam"
                        rules="required">
                        <veui-radio-group
                            :items="store.trueFalseDatasource"
                            v-model="store.parameter.complexBodyParam"
                            @change="complexBodyParamChanged"/>
                    </veui-field>
                    <veui-field label="参数名："
                        name="name"
                        field="name"
                        rules="required">
                        <veui-input v-model="store.parameter.name"
                            :disabled="store.parameter.complexBodyParam"/>
                    </veui-field>
                    <veui-field label="是否必需："
                        name="required"
                        field="required"
                        rules="required">
                        <veui-radio-group
                            :items="store.trueFalseDatasource"
                            v-model="store.parameter.required"/>
                    </veui-field>
                    <veui-field label="默认值："
                        v-if="!store.parameter.required"
                        name="defaultValue"
                        field="defaultValue"
                        rules="required">
                        <veui-input v-model="store.parameter.defaultValue"/>
                    </veui-field>
                    <veui-field label="位置："
                        name="location"
                        field="location"
                        rules="required">
                        <veui-select :options="store.locationDatasource"
                            v-model="store.parameter.location"
                            :disabled="store.parameter.complexBodyParam"/>
                    </veui-field>

                    <veui-field label="参数类型："
                        name="type"
                        field="type"
                        rules="required">
                        <veui-select :options="store.parameterTypeDatasource"
                            v-model="store.parameter.type"
                            :disabled="store.parameter.complexBodyParam"/>
                    </veui-field>
                    <veui-field label="参数说明："
                        name="description"
                        field="description"
                        rules="required">
                        <veui-textarea v-model="store.parameter.description"/>
                    </veui-field>
                </veui-form>
                <template slot="foot">
                    <veui-button ui="primary" @click="$refs.paramForm.submit()">保存</veui-button>
                    <veui-button @click="paramDialogVisible = false">取消</veui-button>
                </template>
            </veui-dialog>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {
    Form,
    Steps,
    Field,
    Button,
    Input,
    Span,
    Dialog,
    Textarea,
    RadioGroup,
    Table,
    Column,
    Checkbox,
    Select
} from 'veui';
import pageTypeMixin from '@/common/mixins/pageType';
import {findIndex, cloneDeep} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'AccountView',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-dialog': Dialog,
        'veui-textarea': Textarea,
        'veui-radio-group': RadioGroup,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-checkbox': Checkbox,
        'veui-select': Select
    },
    data() {
        return {
            steps: [
                {label: '新建API'},
                {label: '沙盒测试'},
                {label: '提交审核'}
            ],
            operationType: null,
            paramDialogVisible: false,
            isEditParam: false
        };
    },
    computed: {
        isGetMethod() {
            return this.store.formData.requestMethod === 0;
        },
        isNoSignType() {
            return this.store.formData.signType === 0;
        },
        isNoAuthType() {
            return this.store.formData.authType === 0;
        }
    },
    mixins: [pageTypeMixin],
    mounted() {
        if (this.isDetail) {
            this.steps.splice(2, 1); // 去除提交审核步骤
        }
    },
    methods: {
        goToTest({id}) {
            let action =  this.isDetail ? 'detail' : 'edit';
            this.global.redirect({
                url: this.store.getApiTestUrl(id, action),
                type: 'push'
            });
        },
        backToService() {
            this.global.redirect({
                url: this.store.getServiceListUrl(),
                type: 'push'
            });
        },
        openAddParamDialog() {
            this.$refs.paramForm.reset();
            this.paramDialogVisible = true;
            this.isEditParam = false;
        },
        complexBodyParamChanged(value) {
            if (value) {
                this.store.parameter.name = 'data';
                this.store.parameter.type = 'String';
                this.store.parameter.location = 'body';
            }
            else {
                this.store.parameter.name = '';
            }
        },
        async addParameter(data) {
            let index = this.findParameterIndex(data.name);
            if (index !== -1) {
                if (!this.isEditParam) {
                    // 添加参数
                    let res = await this.waitConfirm('参数名重复，是否覆盖该参数？', '覆盖确认');
                    if (!res) {
                        return;
                    }
                }
                this.store.formData.parameters.splice(index, 1, data);
            }
            else {
                this.store.formData.parameters.push(data);
            }
            this.paramDialogVisible = false;
        },
        editParameter(name) {
            let index = this.findParameterIndex(name);
            if (index !== -1) {
                this.openAddParamDialog();
                this.store.parameter = cloneDeep(this.store.formData.parameters[index]);
                this.isEditParam = true;
            }
        },
        removeParameter(name) {
            let index = this.findParameterIndex(name);
            if (index !== -1) {
                this.store.formData.parameters.splice(index, 1);
            }
        },
        findParameterIndex(name) {
            return findIndex(this.store.formData.parameters, param => param.name === name);
        }
    }
});
</script>

<style lang="less">
@import '~veui-theme-one/variables.less';

.custom-api-form-view {
    @form-label-width: 160px;

    h3.section {
        border-bottom: 1px solid @veui-text-color-aux;
        padding-top: 1em;
        padding-bottom: 1em;
    }
    h4,
    h3.section {
        color: @veui-text-color-strong;
    }

    .veui-field.added-params {
        margin-bottom: 15px;
    }
    .veui-span.proxy-url {
        display: block;
        margin-left: @form-label-width;
    }
    .veui-select {
        width: 210px;
    }

    .veui-table {
        margin-bottom: 30px;
    }

    .veui-field .veui-form-label {
        width: @form-label-width;
    }
}
.parameter-dialog {
    .veui-dialog-content {
        width: 650px;
        .veui-dialog-content-body {
            height: 550px;
            margin: 10px 50px;
            overflow-y: auto;
        }
    }
}

</style>
